import { render, staticRenderFns } from "./personalCommission.vue?vue&type=template&id=f0cceb82&scoped=true&"
import script from "./personalCommission.vue?vue&type=script&lang=js&"
export * from "./personalCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cceb82",
  null
  
)

export default component.exports